var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.storeType == 'Pure Player')?_c('FBPP'):_vm._e(),(_vm.$store.state.storeType !== 'Pure Player')?_c('FBBRICK'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }